import * as client from './baseClient';

export const getEventsByBranch = (branchId) =>
  client.get(`/api/events/branch/${branchId}`);

export const getEventsByCompany = (companyId) =>
  client.get(`/api/events/company/${companyId}`);

export const createEvent = (event, loggedInUserId) =>
  client.post('/api/events', event, undefined, loggedInUserId);

export const editEvent = (event, loggedInUserId) =>
  client.put(`/api/events/${event.id}`, event, undefined, loggedInUserId);

export const deleteEvent = (eventId, loggedInUserId) =>
  client._delete(
    `/api/events/${eventId}`,
    undefined,
    undefined,
    loggedInUserId
  );

export const getRecordsForEvent = (eventId) =>
  client.get(`/api/events/${eventId}/records`);

export const deleteEventRecord = (payload, loggedInUserId) =>
  client._delete(
    `/api/events/${payload.eventId}/records/${payload.recordId}`,
    undefined,
    undefined,
    loggedInUserId
  );

export const createRecord = (payload, loggedInUserId) =>
  client.post(
    `/api/events/${payload.eventId}/records`,
    payload,
    undefined,
    loggedInUserId
  );

export const updateRecord = (payload, loggedInUserId) =>
  client.put(
    `/api/events/${payload.eventId}/records/${payload.id}`,
    payload,
    undefined,
    loggedInUserId
  );
